import React, { useState,useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Tooltip } from "react-tooltip";
import CheckCurrentPlan from "../../../../components/CheckCurrentPlan";
import { submitTemplate, updateTemplateDetail } from "../../../../utils/spinningWheelApi";
import '../../../../assets/css/loader.css'; 

//Import Widgets
import CommonTemplate from "../../../../components/Apps/SpinningWheel/Template/CommonTemplate";

//Import Tabs
import ContentTab from "../../../../components/Apps/SpinningWheel/ContentTab";
import SettingsTab from "../../../../components/Apps/SpinningWheel/SettingsTab";
import NotificationsTab from "../../../../components/Apps/SpinningWheel/NotificationsTab";
import ThemeTab from "../../../../components/Apps/SpinningWheel/ThemeTab";

export default function CreateSpinningWheel() {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(true);
    const [showTemplateSelection, setShowTemplateSelection] = useState(true);
    const [activeSection, setActiveSection] = useState("Content");
    const [activeTemplateSection, setActiveTemplateSection] = useState("Spin_Win_Temp");
    const [selectedLayout, setSelectedLayout] = useState("spin_win_layout");
    const [selectedTemplateImage, setSelectedTemplateImage] = useState("spin-win.png");
    const [renameWidgetNameModel, setRenameWidgetNameModel] = useState(false);
    const [widgetName, setWidgetName] = useState("Untitled Spinning Wheel");
    const [isTemplateId, setTemplateId] = useState(null);
    const [newWidgetName, setNewWidgetName] = useState("");
    const [refreshWidgetList, setRefreshWidgetList] = useState(false);
    
    const [spinningWheelTabData, setSpinningWheelTabData] = useState({
        is_website_frontend: "",  
        heading: "",
        description: "",
        is_show_email: 1,
        logo: 1,
        footer_text: "",
        show_popup_type: "Instantly",
        is_show_reopen_button: 1,
        button_text: "",
        button_icon: "",
        button_position: "right-side",
        pages_types: "All_Pages",
        devices_types: "All_Pages",
        language_types: "English",
        is_prize_confirmation_to_client: 1,
        is_owner_notification: 1,
        owner_email: "",
        background_color: "",
        text_color: "",
        accent_color: "",
        email_field_error_color: "",
        font_type: "Default",
        custom_css: "",   
        custom_js: "",   
    });

    // Set Template Setting And Texts when activeTemplateSection changes
        useEffect(() => {
            let heading = "";
            let description = "";
            let button_text = "";
            let background_color = "";
            let text_color = "";
            let accent_color = "";
            let email_field_error_color = "";
        
            switch (activeTemplateSection) {
                case "Spin_Win_Temp":
                    heading = "Spin & Win!";
                    description = "Try your luck and spin the wheel for a chance to win exciting rewards. What will you win today?";
                    button_text = "Spin To Win";
                    background_color = "#fff";
                    text_color = "rgb(17, 17, 17)";
                    accent_color = "#012a75";
                    email_field_error_color = "rgb(255, 56, 56)";
                    break;
                case "Discount_Temp":
                    heading = "Spin & Win Exciting Discounts!";
                    description = "Spin the wheel now to unlock amazing discounts and special offers just for you. Every spin is a chance to save big!";
                    button_text = "% Spin To Save";
                     background_color = "#fff";
                    text_color = "rgb(17, 17, 17)"; 
                    accent_color = "#ed2c2c";
                    email_field_error_color = "rgb(255, 56, 56)";
                    break;
                case "Email_Collection_Temp":
                    heading = "Spin the Wheel and Unlock Your Reward!";
                    description = "Spin the wheel now to win amazing discounts and exclusive offers just for sharing your email. Your next great deal is just a spin away!";
                    button_text = "Play to Win";
                    background_color = "#fff";
                    text_color = "rgb(17, 17, 17)";
                    accent_color = "#0f0f0f";
                    email_field_error_color = "rgb(255, 56, 56)";
                    break;
                case "Loyalty_Rewards_Temp":
                    heading = "Spin to Win Your Loyalty Rewards!";
                    description = "Spin the wheel and discover exclusive discounts and bonus points just for being a valued customer.";
                    button_text = "Lucky Spin";
                    background_color = "#fff";
                    text_color = "rgb(17, 17, 17)";
                    accent_color = "#09801a";
                    email_field_error_color = "rgb(255, 56, 56)";
                    break;
                case "Black_Friday_Deals_Temp":
                    heading = "Spin & Win Big This Black Friday!";
                    description = "Don’t miss out on exclusive deals! Spin the wheel now for your chance to grab amazing discounts and offers.";
                    button_text = "Black Friday Sale";
                    background_color = "#000";
                    text_color = "#fff";
                    accent_color = "#b00c0c";
                    email_field_error_color = "rgb(255, 56, 56)";
                    break;
                case "Cyber_Monday_Deals_Temp":
                    heading = "Spin to Unlock Cyber Monday Savings!";
                    description = "Get ready to score unbeatable deals! Spin the wheel now and discover exclusive discounts just for you.";
                    button_text = "Cyber Monday Sale";
                    background_color = "#17167e";
                    text_color = "#fff";
                    accent_color = "#a201ae";
                    email_field_error_color = "rgb(255, 56, 56)";
                    break;
                default:
                    heading = "";
                    description = "";
                    button_text = "";
                    background_color = "";
                    text_color = "";
                    accent_color = "";
                    email_field_error_color = "";
            }
        
            // Update setSpinningWheelTabData state with the data
            setSpinningWheelTabData((prevData) => ({
                ...prevData,
                heading: heading,
                description: description,
                button_text: button_text,
                background_color: background_color,
                text_color: text_color,
                accent_color: accent_color,
                email_field_error_color: email_field_error_color,
            }));
        
        }, [activeTemplateSection]);

    // Open Widget Name Popup
    const openRenameWidgetNamePopup = () => {
        setNewWidgetName(widgetName);
        setRenameWidgetNameModel(true);
        document.body.classList.add("popup-open");
    };

    // Close Widget Name Popup
    const closeRenameWidgetNamePopup = () => {
        setRenameWidgetNameModel(false);
        document.body.classList.remove("popup-open");
    };

    // Save Widget Name Popup
    const saveWidgetName = () => {
        if (newWidgetName.trim() !== "") {
            setWidgetName(newWidgetName); 
        }
        closeRenameWidgetNamePopup();
    };

    // Function to update values dynamically
    const updateSpinningWheelTabData = (key, value) => {
        setSpinningWheelTabData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const handleContinueTemplate = async () => {
        setShowTemplateSelection(false);
        setIsSubmitting(false);
        //Get the currently checked radio button
        const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
        if (selectedRadio) {
            const layoutTypeValue = selectedRadio.dataset.layout_type;
            setSelectedLayout(layoutTypeValue);
        } else {
            alert('Please select a template');
        } 

       //Call Api To Create Templates with dummy data first
        try {
            // Collect data from refs
            const settingsArray = Object.entries(spinningWheelTabData).map(([key, value]) => ({
                setting_key: key,
                setting_value: value,
            }));

            // Collect data from refs
            const payload = {
                    name: widgetName,
                    template_name: activeTemplateSection,
                    template_image: selectedTemplateImage,
                    layout_name: selectedLayout,
                    layout_type: selectedLayout,
                    app_type: "Spinning_Wheel",
                    settings: settingsArray,
            };
            //setTemplateId("fdd1e4e7-d01a-4db4-aab2-d67918b671fa"); 
            //Api Call
            let api_response = await submitTemplate(payload);

            //Check Responce
            if (api_response.status === true) { 
                // Save templateId after first creation
                if (api_response.data.template_id) {
                    setTemplateId(api_response.data.template_id); 
                }
                setIsSubmitting(false); 
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error('Oops Something Wrong. Please Try Again!' + error.message);
        }
  }; 

  const menuItems = [
      { key: "Content", icon: "content.png", label: "Content" },
      { key: "Settings", icon: "settings.png", label: "Settings" },
      { key: "Notifications", icon: "notifications.png", label: "Notifications" },
      { key: "Theme", icon: "theme.png", label: "Theme" },
  ];

  // Handle Source Tab input change
  const handleActiveTemplateInputChange = (event) => {
        setActiveTemplateSection(event.target.value);
        //Get the currently checked radio button
        const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
        if (selectedRadio) {
            const layoutTypeValue = selectedRadio.dataset.layout_type;
            const template_image = selectedRadio.dataset.template_image;
            setSelectedLayout(layoutTypeValue);
            setSelectedTemplateImage(template_image);
        } else {
            alert('Please select a template');
        }
    };

    //Update Form data
    const updateForm = async (e) => {
        e.preventDefault();

        setIsSubmitting(true);
        try {
            // Convert settings object back into an array of key-value pairs
            const updateSettingsArray = Object.entries(spinningWheelTabData).map(([key, value]) => ({
                setting_key: key,
                setting_value: value,
            }));

            // Collect data from refs
            const payload = {
                template_id: isTemplateId,
                name: widgetName,
                template_name: activeTemplateSection,
                template_image: selectedTemplateImage,
                layout_name: selectedLayout,
                layout_type: selectedLayout,
                settings: updateSettingsArray,
            };
            
            //Api Call
            let api_response = await updateTemplateDetail(payload);

            //Check Responce
            if (api_response.status === true) {
                toast.success("Submitted Successfully.");
                // Redirect after 2 seconds
                setTimeout(() => {
                    navigate('/customer/apps/spinning-wheel');
                }, 2000); 
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error('Oops Something Wrong. Please Try Again!' + error.message);
        }
    };

  return (
    <>
      <div className="create-goole-reviews-all">
            <CheckCurrentPlan from_page={true} app_name="Spinning Wheel" app_type="Spinning_Wheel" app_slug="spinning-wheel"/>
            {showTemplateSelection ? (
                <div className="create-goole-reviews-side">
                    <span>Select a template to start with</span>
                    <div className="card h-100">
                        <div className="label-box-flex">
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Spin_Win_Temp" data-layout_type="spin_win_layout" data-template_image="spin-win.png" checked={activeTemplateSection === "Spin_Win_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/spinning-wheel/templates/spin-win.png`} alt="spin-win" />
                                    </div> 
                                    <div className="content_sub">Spin & Win Wheel</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Discount_Temp" data-layout_type="discount_layout" data-template_image="discount.png" checked={activeTemplateSection === "Discount_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/spinning-wheel/templates/discount.png`} alt="discount" />
                                    </div> 
                                    <div className="content_sub">Discount Wheel</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Email_Collection_Temp" data-layout_type="email_collection_layout" data-template_image="email-collection.png" checked={activeTemplateSection === "Email_Collection_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/spinning-wheel/templates/email-collection.png`} alt="email-collection" />
                                    </div> 
                                    <div className="content_sub">Email Collection Wheel</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Loyalty_Rewards_Temp" data-layout_type="loyalty_rewards_layout" data-template_image="loyalty-rewards.png" checked={activeTemplateSection === "Loyalty_Rewards_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/spinning-wheel/templates/loyalty-rewards.png`} alt="loyalty-rewards" />
                                    </div> 
                                    <div className="content_sub">Loyalty Rewards Wheel</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Black_Friday_Deals_Temp" data-layout_type="black_friday_deals_layout" data-template_image="black-friday-deals.png" checked={activeTemplateSection === "Black_Friday_Deals_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/spinning-wheel/templates/black-friday-deals.png`} alt="black-friday-deals" />
                                    </div> 
                                    <div className="content_sub">Black Friday Deals Wheel </div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Cyber_Monday_Deals_Temp" data-layout_type="cyber_monday_deals_layout" data-template_image="cyber-monday-deals.png" checked={activeTemplateSection === "Cyber_Monday_Deals_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/spinning-wheel/templates/cyber-monday-deals.png`} alt="cyber-monday-deals" />
                                    </div> 
                                    <div className="content_sub">Cyber Monday Deals Wheel</div>
                                </div>
                            </label>
                        </div>
                    </div>
                    <div className="continue-template">
                        <button onClick={handleContinueTemplate}>Continue with this template</button>
                    </div>
                </div>
            ) : (
                <>
                    <div className="overlay-side-baar">
                        <div className="side-baar-inner-one">
                            <ul>
                                {menuItems.map((item) => (
                                    <li key={item.key}>
                                        <button
                                            className={activeSection === item.key ? "active" : ""}
                                            onClick={() => setActiveSection(item.key)}
                                        >
                                            <img
                                                src={`${process.env.PUBLIC_URL}/spinning-wheel/icons/${item.icon}`}
                                                alt={`${item.key} icon`}
                                            />
                                            <span>{item.label}</span>
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="side-baar-inner-tow">
                            {/* Conditional Rendering for Sections */}
                            {activeSection === "Content" && (
                              <ContentTab isTemplateId={isTemplateId} setTemplateId={setTemplateId} updateSpinningWheelTabData={updateSpinningWheelTabData} spinningWheelTabData={spinningWheelTabData} setRefreshWidgetList={setRefreshWidgetList} />
                            )}
                            {activeSection === "Settings" && (
                              <SettingsTab updateSpinningWheelTabData={updateSpinningWheelTabData} spinningWheelTabData={spinningWheelTabData} />
                            )}
                            {activeSection === "Notifications" && (
                              <NotificationsTab updateSpinningWheelTabData={updateSpinningWheelTabData} spinningWheelTabData={spinningWheelTabData} />
                            )}
                            {activeSection === "Theme" && (
                              <ThemeTab updateSpinningWheelTabData={updateSpinningWheelTabData} spinningWheelTabData={spinningWheelTabData} />
                            )}
                        </div>
                    </div>
                </>
            )}
            <div className="create-goole-reviews-right">
                <div className="content-wrapper count-add-class">
                    <div className="source-header-row">
                        <h2><Link to="/customer/apps/spinning-wheel"><i className="fa fa-angle-left" aria-hidden="true"></i> Back</Link></h2>
                        <div className="untitled-widget-name">
                            <button onClick={openRenameWidgetNamePopup} data-tooltip-id="rename-tooltip"><img src={`${process.env.PUBLIC_URL}/spinning-wheel/spinning-wheel.svg`} alt="spinning-wheel"/>{ widgetName }</button>
                            <Tooltip id="rename-tooltip" place="top" content="Rename Widget" />
                        </div>
                        <div className='submit-google-review'>
                          <button type="button" onClick={updateForm} className={`form-button ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting}>Publish</button>
                          <Link to="/customer/apps/spinning-wheel/pricing/single" className="view-plan">View Plans</Link>
                          <Link to="/customer/apps/spinning-wheel" className="close-button">Close</Link></div> 
                    </div>
                    <div className="source-title-row">Spinning Wheel <i className="fa fa-angle-right" aria-hidden="true"></i> <strong>Connect</strong></div>

                    {/*Call Common template*/}
                    <CommonTemplate selectedTemplate={activeTemplateSection} isTemplateId={isTemplateId} spinningWheelTabData={spinningWheelTabData} refreshWidgetList={refreshWidgetList} />
                </div>
            </div>
        </div>

        {/* Rename Popup */}
        {renameWidgetNameModel && (
            <div className="fixed top-50 left-50 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden widget-rename-model">
                <div className="bg-white p-3 rounded-lg shadow-lg">
                    <h3 className="text-lg font-semibold">Rename Widget</h3>
                    <label>Widget Name</label>
                    <input
                        type="text"
                        className="border p-2 w-full mt-2"
                        value={newWidgetName}
                        onChange={(e) => setNewWidgetName(e.target.value)}
                    />
                    <div className="mt-3 flex justify-end">
                        <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameWidgetNamePopup}>
                            Cancel
                        </button>
                        <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={saveWidgetName}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        )}
    </>
  );
} 